<template>
  <div class="detail-description-m">
    <div class="relative">
      <Resource
        :src="getFeUrl('/youyan-platform/png/digital-human-top-mask.png')"
        class="absolute top-0 w-full"
      />
      <Resource
        :src="props.character?.cover_url"
        class="w-[80%] left-[10%] relative"
        :resource-option="{
          format: 'webp',
          resize: {
            w: 1000,
            m: 'lfit',
          },
        }"
      />
      <Resource
        :src="getFeUrl('/youyan-platform/png/digital-human-top-mask2.png')"
        class="absolute bottom-[-35%] left-0 w-full"
      />
      <div class="character-name">
        {{ props.character?.name }}
      </div>
    </div>
    <div class="bg-back-0 rounded-[12px] mt-[26px] relative mx-[12px]">
      <div v-if="character?.description" class="p-[20px]">
        <div class="text-[15px] font-semibold">
          {{ $t('ren-wu-jie-shao') }}:
        </div>
        <p class="text-13 font-light mt-[10px]">
          {{ character?.description }}
        </p>
      </div>
      <div v-if="character?.description" class="bg-back-3 h-[1px]"></div>
      <div class="mt-[16px] flex flex-wrap gap-y-[10px] p-[20px]">
        <template v-if="character?.config?.age">
          <div class="flex-shrink-0">
            {{ $t('nian-ling') }}: {{ character?.config?.age || 'xx' }}
          </div>
          <DividerVertical class="flex-shrink-0" />
        </template>
        <template v-if="character?.config?.gender">
          <div class="flex-shrink-0">
            {{ $t('xing-bie') }}:
            {{ character?.config?.gender === 'Male' ? '男' : '女' }}
          </div>
          <DividerVertical class="flex-shrink-0" />
        </template>
        <template v-if="character?.online_time">
          <div class="flex-shrink-0">
            {{ $t('dan-sheng-ri-qi') }}:
            {{ timeFormat(character?.online_time, 'YYYY-MM-DD') }}
          </div>
          <DividerVertical class="flex-shrink-0" />
        </template>
        <div
          v-if="character?.homepage_org_name"
          class="flex items-center flex-shrink-0"
        >
          <span>{{ $t('chuang-jian-zhe') }}:</span>
          <Resource
            class="h-[18px] w-[18px]"
            :src="character?.avatar_url"
            :transform-resource="transformImage"
          />
          <span class="ml-[4px]">{{ character?.homepage_org_name }}</span>
        </div>
      </div>
      <div class="bg-back-3 h-[1px]"></div>
      <div class="p-[20px] grid grid-cols-1 gap-y-[20px]">
        <TagCom
          v-for="tag in tags"
          :key="tag.tag_id"
          :tag="tag"
          :character="character"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import TagCom from '../tag.vue'
import DividerVertical from '../divider-vertical.vue'
import type { DetailTag } from './interface'
import type { Character } from '~/api/interface/character'
import { useTime } from '~/hooks/useTime'

interface DetailDescriptionProps {
  character?: Character | null
  tags: DetailTag[]
}

const props = defineProps<DetailDescriptionProps>()

const bgUrl = computed(
  () => `url(${getFeUrl('/youyan-platform/png/digital-human-detail-bg.png')})`
)

const { timeFormat } = useTime()
</script>
<style lang="scss" scoped>
.detail-description-m {
  background-image: v-bind(bgUrl);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  .character-name {
    position: absolute;
    background: linear-gradient(270deg, #ef17fd 0%, #05d4ff 100%);
    background-clip: text;
    color: transparent;
    font-size: 36px;
    font-weight: 900;
    top: vw(110);
    left: vw(256);
  }
}
</style>
